// Header.js
import React, { useState } from "react";
import "../styles/header.css";
import RonniLogo from "../assets/logo.png";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="home-header">
      <div className="logo-container">
        <a href="/">
          <img
            src={RonniLogo}
            alt="Ronni Ceramics Logo"
            className="ronni-logo"
          />
        </a>
      </div>
      <nav className={`home-nav ${isMenuOpen ? "open" : ""}`}>
        <a href="/" className="nav-link" onClick={toggleMenu}>
          Shtëpia
        </a>
        <a href="/about-us" className="nav-link" onClick={toggleMenu}>
          Rreth Nesh
        </a>
        <a href="/shop" className="nav-link" onClick={toggleMenu}>
          Dyqani
        </a>
        <a href="/contact-us" className="nav-link" onClick={toggleMenu}>
          Na Kontaktoni
        </a>
      </nav>
      <button
        className={`hamburger ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>
    </header>
  );
};

export default Header;
